import React from "react";
import { getIcon } from "../../helpers/icons";
import style from './style.module.css';
import Tooltip from "./index";
const WithIcon = ({ children, className, icon = "Question" }) => {
    return (
        <div className={`${style.withIcon}${className ? ` ${className}` : ``}`}>
            <i className={getIcon(icon)}></i>
            <Tooltip>{children}</Tooltip>
        </div>
    )
}
export default WithIcon;